import { Routes } from "@angular/router";
import { AuthGuard } from "./services/guard/auth.guard";
import { VoucherModule } from "./features/voucher/voucher.module";

export const routes: Routes = [
  {
    path: "public",
    loadChildren: () =>
      import("./features/public/public.module").then((m) => m.PublicModule),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./features/dashboard/dashboard.module").then(
        (m) => m.DashboardModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "delivery",
    loadChildren: () =>
      import("./features/delivery/delivery.module").then(
        (m) => m.DeliveryModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "order",
    loadChildren: () =>
      import("./features/order/order.module").then((m) => m.OrderModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "contact",
    loadChildren: () =>
      import("./features/contact/contact.module").then((m) => m.ContactModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },

  {
    path: "voucher",
    loadChildren: () =>
      import("./features/voucher/voucher.module").then((m) => m.VoucherModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "template",
    loadChildren: () =>
      import("./features/template/template.module").then(
        (m) => m.TemplateModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "team-inbox",
    loadChildren: () =>
      import("./features/team-inbox/team-inbox.module").then(
        (m) => m.TeamInboxModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "analytics-chat",
    loadChildren: () =>
      import("./features/analytics-chat/analytics-chat.module").then(
        (m) => m.AnalyticsChatModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "manage-ticket",
    loadChildren: () =>
      import("./features/manage-ticket/manage-ticket.module").then(
        (m) => m.ManageTicketModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "broadcast",
    loadChildren: () =>
      import("./features/broadcast/broadcast.module").then(
        (m) => m.BroadcastModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "automations",
    loadChildren: () =>
      import("./features/automations/automations.module").then(
        (m) => m.AutomationsModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "solution",
    loadChildren: () =>
      import("./features/solution/solution.module").then(
        (m) => m.SolutionModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./features/profil/profile.module").then((m) => m.ProfileModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "administration",
    loadChildren: () =>
      import("./features/administration/administration.module").then(
        (m) => m.AdministrationModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "referential",
    loadChildren: () =>
      import("./features/referential/referential.module").then(
        (m) => m.ReferentialModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "",
    redirectTo: "/analytics-chat",
    pathMatch: "full",
  },
  {
    path: "product",
    loadChildren: () =>
      import("./features/product/product.module").then((m) => m.ProductModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "payment",
    loadChildren: () =>
      import("./features/payment/payment.module").then((m) => m.PaymentModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "reservation",
    loadChildren: () =>
      import("./features/reservation/reservation.module").then(
        (m) => m.ReservationModule,
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
  }
];
